export default __webpack_public_path__ + "static/media/phone.0c9442b5.svg";